document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("inline").forEach((inline) => {
    const src = inline.getAttribute("data");
    const preload = inline.getAttribute("preload");
    if (src) {
      if (preload) {
        inline.innerHTML = `<img src="${src}" />`;
      }

      fetch(src)
        .then((response) => response.text())
        .then((svg) => {
          inline.outerHTML = svg;
        })
        .catch((error) => console.error(error));
    }
  });

  document.querySelectorAll("marquee").forEach((marquee) => {
    const inner = marquee.innerHTML;

    marquee.setAttribute("loop", "-1");
    marquee.setAttribute("behaviour", "scroll");
    marquee.setAttribute("direction", "left");
    marquee.setAttribute("scrollamount", "5");

    let content = inner.trim();

    for (let index = 0; index < 20; index++) {
      content += inner.trim();
    }

    marquee.innerHTML = content;
  });

  document.querySelectorAll("sticker").forEach((sticker) => {
    const refresh = () => {
      const width = parseInt(sticker.getAttribute("width")) || 3;
      const color = sticker.getAttribute("color") || "#FFF";

      const shadows = [];
      for (let angle = 0; angle < 2 * Math.PI; angle += 1 / width) {
        const x = Math.round(Math.cos(angle) * width);
        const y = Math.round(Math.sin(angle) * width);
        shadows.push({ x, y });
      }

      sticker.style.textShadow = shadows
        .map((s) => `${s.x}px ${s.y}px ${color}`)
        .join(", ");
    };

    refresh();
  });

  document.querySelectorAll("[\\$color]").forEach((thing) => {
    const color = thing.getAttribute("$color");
    if (color) {
      thing.style.backgroundColor = color;
    }
  });

  document.querySelectorAll("[\\$side]").forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const locked = element.classList.contains("--locked");

      const variant = element.getAttribute("$side");
      if (variant && !locked) {
        CartJS.addItem(variant, 1);
        document.getElementById("side").classList.add("--active");
      }
    });
  });

  document.querySelectorAll("[\\$change]").forEach((element) => {
    element.addEventListener("click", () => {
      const url = element.getAttribute("$change");

      if (url) {
        const loader = document.querySelector(".page-loader");
        if (loader) loader.classList.add("--active");

        window.location.href = url;
      }
    });
  });

  document.querySelectorAll("[\\$repeat]").forEach((thing) => {
    const repeat = thing.getAttribute("$repeat");
    const times = parseInt(repeat, 10);

    if (times) {
      const parent = thing.parentNode;
      const clones = [thing];
      for (let i = 1; i < times; i++) {
        const clone = thing.cloneNode(true);
        parent.insertBefore(clone, clones[clones.length - 1].nextSibling);
        clones.push(clone);
      }
      clones.forEach((el, idx) => {
        el.querySelectorAll("[src]").forEach((srcEl) => {
          const src = srcEl.getAttribute("src");
          if (src && src.includes("$index")) {
            srcEl.setAttribute("src", src.replace(/\$index/g, idx));
          }
        });
      });
    }
  });

  document.querySelectorAll("[\\$toggle]").forEach((thing) => {
    const selector = thing.getAttribute("$toggle");
    const value = thing.getAttribute("$value");

    thing.addEventListener("click", (event) => {
      const find = document.querySelectorAll(selector);

      find.forEach((found) => {
        found.classList.toggle(value);
      });
    });
  });

  (() => {
    const heros = document.getElementsByClassName("hero");

    for (const hero of heros) {
      const _progress = () => {
        return hero.querySelector(".progress");
      };

      const _bullets = () => {
        return hero.querySelector(".bullets");
      };

      const _restructure = (index, length) => {
        // Generalized from "article" to every per-slide element (text,
        // button, overlay, clickable-image link — anything carrying
        // data-hero-index) so all of them switch slides together, not
        // just the text block. Matched by the attribute's value, not
        // NodeList position, since a given hero can render zero to
        // several of these depending on which optional fields it uses.
        const positioned = hero.querySelectorAll("[data-hero-index]");

        const component = _bullets();
        if (!component) {
          return;
        }

        let content = "";

        for (let i = 0; i < length; i++) {
          if (i === index) {
            content += `<div class="progress"><div></div></div>`;
          } else {
            content += `<div class="dot"></div>`;
          }
        }

        positioned.forEach((el) => {
          const elIndex = parseInt(el.getAttribute("data-hero-index"), 10);
          el.style.display = elIndex === index ? "" : "none";
        });

        component.innerHTML = content;
      };

      if (hero) {
        const videosOrImages = hero.querySelectorAll(".--item");

        const clearAllActive = () => {
          videosOrImages.forEach((el) => {
            el.classList.remove("--visible");
            el.classList.remove("--active");
          });
        };

        const activateVideo = (video) => {
          video.currentTime = 0;
          video.play().catch((err) => console.error(`[hero] play rejected:`, err.name, err.message));
          video.classList.add("--active");
        };

        const deactivateVideo = (video) => {
          video.classList.remove("--active");
          video.pause();
          video.currentTime = 0;
        };

        // Defined outside forEach so it recomputes nextIsVideo/nextIsImage from its own
        // local nextIndex each call — not from a stale per-element closure.
        const startFakeProgress = (currentIndex) => {
          const nextIndex = currentIndex === videosOrImages.length - 1 ? 0 : currentIndex + 1;
          const nextEl = videosOrImages[nextIndex];
          const nextIsVideo = nextEl.tagName.toLowerCase() === "video";
          const nextIsImage = nextEl.tagName.toLowerCase() === "img";
          const DURATION = 5000;
          const startTime = performance.now();

          const tick = (now) => {
            const component = _progress();
            if (!component) return;

            const kid = component.querySelector("div");
            if (!kid) return;

            const elapsed = now - startTime;
            const percentage = Math.min((elapsed / DURATION) * 100, 100);
            kid.style.width = `${percentage}%`;

            if (elapsed < DURATION) {
              requestAnimationFrame(tick);
            } else {
              clearAllActive();

              if (nextIsVideo) {
                activateVideo(videosOrImages[nextIndex]);
              }

              if (nextIsImage) {
                videosOrImages[nextIndex].classList.add("--visible");
                startFakeProgress(nextIndex);
              }

              _restructure(nextIndex, videosOrImages.length);
            }
          };

          requestAnimationFrame(tick);
        };

        videosOrImages.forEach((element, index) => {
          const isVideo = element.tagName.toLowerCase() === "video";
          const isImage = element.tagName.toLowerCase() === "img";
          const isFirst = index === 0;

          if (isImage && isFirst) {
            element.classList.add("--visible");
            startFakeProgress(index);
          }

          if (isVideo) {
            element.addEventListener("ended", () => {
              const nextIndex = (index + 1) % videosOrImages.length;
              const nextEl = videosOrImages[nextIndex];
              const nextIsVideo = nextEl.tagName.toLowerCase() === "video";
              const nextIsImage = nextEl.tagName.toLowerCase() === "img";

              if (nextIsVideo) {
                activateVideo(videosOrImages[nextIndex]);
              }

              if (nextIsImage) {
                videosOrImages[nextIndex].classList.add("--visible");
                startFakeProgress(nextIndex);
              }

              deactivateVideo(element);
              _restructure(nextIndex, videosOrImages.length);
            });

            element.ontimeupdate = () => {
              requestAnimationFrame(() => {
                const component = _progress();
                if (!component) return;
                const kid = component.querySelector("div");
                if (!kid) return;
                const percentage = (element.currentTime / element.duration) * 100;
                kid.style.width = `${percentage}%`;
              });
            };

            if (isFirst) {
              activateVideo(element);
            }
          }
        });

        videosOrImages.forEach((el) => {
          if (el.tagName.toLowerCase() === "video" && !el.classList.contains("--active")) {
            el.pause();
            el.currentTime = 0;
          }
        });
      }
    }
  })();

  (() => {
    const videos = document.querySelectorAll(".product video");

    videos.forEach((video) => {
      video.addEventListener("mouseenter", () => {
        video.play();
      });

      video.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  })();

  (() => {
    const arrows = document.querySelectorAll(".products.--spotlight .drawer .bullets icon");

    arrows.forEach((arrow) => {
      const isLeft = arrow.classList.contains("--left");

      arrow.addEventListener("click", () => {
        const drawer = arrow.parentNode.parentNode;
        const scroll = drawer.querySelector(".scroll");
        if (!scroll) return;

        const maxScroll = scroll.scrollWidth - scroll.clientWidth;
        const current   = scroll.scrollLeft;
        const target    = isLeft
          ? Math.max(0, current - scroll.clientWidth)
          : Math.min(maxScroll, current + scroll.clientWidth);

        scroll.scrollTo({ left: target, behavior: "smooth" });

        // Dim inactive arrow after scroll settles
        setTimeout(() => {
          const newPos     = scroll.scrollLeft;
          const leftArrow  = drawer.querySelector(".bullets icon.--left");
          const rightArrow = drawer.querySelector(".bullets icon.--right");
          if (leftArrow)  leftArrow.style.opacity  = newPos <= 0              ? "0.25" : "1";
          if (rightArrow) rightArrow.style.opacity = newPos >= maxScroll - 1  ? "0.25" : "1";
        }, 350);
      });
    });
  })();

  (() => {
    const accordions = document.querySelectorAll(".accordion .item");

    accordions.forEach((item, i) => {
      item.addEventListener("click", () => {
        accordions.forEach((el, j) => {
          el.classList.remove("--open");
        });

        item.classList.add("--open");
      });
    });
  })();

  (() => {
    const items = document.querySelectorAll(".tabs .header .item");

    items.forEach((item, i) => {
      const parent = item.parentNode.parentNode;

      item.addEventListener("click", () => {
        const value = item.getAttribute("$value");
        const bodies = parent.querySelectorAll(".body");
        const subs = parent.querySelectorAll(".header .item");

        bodies.forEach((body) => {
          body.classList.remove("--open");
        });

        subs.forEach((sub) => {
          sub.classList.remove("--active");
        });

        item.classList.add("--active");

        const body = parent.querySelector(`.body[\\$tab="${value}"]`);
        if (body) {
          body.classList.add("--open");
        }
      });
    });
  })();

  (() => {
    const headers = document.querySelectorAll(".sidebar .group .header");

    headers.forEach((item, i) => {
      const parent = item.parentNode;

      item.addEventListener("click", () => {
        parent.classList.toggle("--close");
      });
    });
  })();

  (() => {
    const headers = document.querySelectorAll(".toggles .group .header");

    headers.forEach((item, i) => {
      const parent = item.parentNode;

      item.addEventListener("click", () => {
        parent.classList.toggle("--close");
      });
    });
  })();

  (() => {
    const dropdowns = document.querySelectorAll(".dropdown .trigger");

    dropdowns.forEach((item, i) => {
      const parent = item.parentNode;

      item.addEventListener("click", (e) => {
        parent.classList.toggle("--active");
      });

      document.addEventListener("click", (event) => {
        if (
          !item.contains(event.target) &&
          parent.classList.contains("--active")
        ) {
          parent.classList.remove("--active");
        }
      });
    });
  })();

  (() => {
    const closes = document.querySelectorAll(".popup .close");

    closes.forEach((item) => {
      item.addEventListener("click", () => {
        const popups = document.querySelectorAll(".popup");
        popups.forEach((popup) => {
          popup.classList.remove("--active");
        });
      });
    });
  })();

  document.addEventListener("scroll", () => {
    const header = document.querySelector("header");
    if (!header) return;

    // Checked via computed style rather than classList.contains("--fixed"):
    // a --fixed header can come from the legacy hardcoded template class
    // (index / page.our-commitment / page.our-purpose) or from the newer
    // fixed_header section setting on customized-collection-page, which
    // applies "position: fixed" via a CSS :has() selector without ever
    // adding a literal --fixed class to the element. Computed style covers
    // both without the JS needing to know which mechanism is in play.
    if (getComputedStyle(header).position === "fixed") {
      header.classList.toggle("--scroll", window.scrollY > 64);
    } else {
      header.classList.remove("--scroll");
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" || event.key === "Esc") {
      const popups = document.querySelectorAll(".popup");

      popups.forEach((popup) => {
        popup.classList.remove("--active");
      });

      const sheets = document.querySelectorAll(".sheet");

      sheets.forEach((sheet) => {
        sheet.classList.remove("--active");
      });

      const side = document.getElementById('side');
      if (side) side.classList.remove('--active');
    }
  });

  (() => {
    const sheets = document.querySelectorAll(".sheet");

    sheets.forEach((sheet) => {
      const content = sheet.querySelector('content');

      sheet.addEventListener('click', (event) => {
        if (content && !content.contains(event.target)) {
          sheet.classList.remove('--active');
        }
      });
    });
  })();

  // Side cart: click backdrop (outside panel) to close
  (() => {
    const side = document.getElementById('side');
    const content = side && side.querySelector('content');
    if (!side || !content) return;

    side.addEventListener('click', (event) => {
      if (!content.contains(event.target)) {
        side.classList.remove('--active');
      }
    });
  })();

  // Cart icon: open side drawer on mobile, navigate on desktop
  (() => {
    const cartLink = document.getElementById('cart-icon-link');
    if (!cartLink) return;

    cartLink.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 640px)').matches) {
        e.preventDefault();
        const side = document.getElementById('side');
        if (side) side.classList.add('--active');
      }
      // Desktop: <a href> navigates to /cart normally
    });
  })();

  // Gallery: thumbnail clicks + mobile swipe with dots
  (() => {
    const main = document.getElementById('slider-main');
    if (!main) return;

    const imgs = main.querySelectorAll('img[data-index]');
    const thumbItems = document.querySelectorAll('.details .slider .items .item');
    const dots = document.querySelectorAll('#slider-dots .slider__dot');

    function setActive(idx) {
      imgs.forEach((img, i) => img.classList.toggle('--active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('--active', i === idx));
      thumbItems.forEach((t, i) => t.classList.toggle('--active', i === idx));
    }

    thumbItems.forEach((item, idx) => {
      item.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 640px)').matches) {
          main.scrollTo({ left: main.clientWidth * idx, behavior: 'smooth' });
        } else {
          setActive(idx);
        }
      });
    });

    if (dots.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(parseInt(entry.target.getAttribute('data-index'), 10) || 0);
          }
        });
      }, { root: main, threshold: 0.5 });
      imgs.forEach((img) => io.observe(img));
    }
  })();

  // Desktop image zoom — always targets the --active image
  (() => {
    const container = document.querySelector('.details .slider .image');
    if (!container) return;

    container.addEventListener('mousemove', (e) => {
      const image = container.querySelector('img.--active') || container.querySelector('img');
      if (!image) return;
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      image.style.transformOrigin = `${x}% ${y}%`;
      image.style.transform = 'scale(2)';
    });

    container.addEventListener('mouseleave', () => {
      const image = container.querySelector('img.--active') || container.querySelector('img');
      if (!image) return;
      image.style.transformOrigin = 'top center';
      image.style.transform = 'scale(1)';
    });
  })();

  (() => {
    const cart = document.getElementById("cart");
    const increase = document.getElementById("increase");
    const decrease = document.getElementById("decrease");
    const selector = document.getElementById("selector");
    const quantity = document.getElementById("quantity");

    if (!cart || !increase || !decrease || !selector || !quantity) {
      return;
    }

    increase.addEventListener("click", () => {
      const value = parseInt(selector.textContent);
      selector.textContent = value + 1;
      quantity.value = value + 1;
    });

    decrease.addEventListener("click", () => {
      const value = parseInt(selector.textContent);
      if (value > 1) {
        selector.textContent = value - 1;
        quantity.value = value - 1;
      }
    });

    cart.addEventListener("click", (event) => {
      event.preventDefault();

      CartJS.addItem(ShopifyAnalytics.meta.selectedVariantId, parseInt(quantity.value));
      document.getElementById("side").classList.add("--active");

      cart.innerHTML = "Added to Cart";
    });
  })();
});

(() => {
  const MOBILE_MAX_WIDTH = 768;

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
  }

  function swapImages() {
    const imgs = document.querySelectorAll('img[mobile]');

    imgs.forEach((img) => {
      const mobileSrc = img.getAttribute('mobile');
      if (!mobileSrc) return;

      if (isMobile()) {
        if (!img.hasAttribute('desktop')) {
          img.setAttribute('desktop', img.currentSrc || img.getAttribute('src') || '');
        }
        img.setAttribute('src', mobileSrc);
      } else {
        if (img.hasAttribute('desktop')) {
          const desktopSrc = img.getAttribute('desktop');
          if (desktopSrc) img.setAttribute('src', desktopSrc);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapImages, { once: true });
  } else {
    swapImages();
  }

  let queued = false;
  window.addEventListener('resize', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      swapImages();
    });
  });
})();

(() => {
  function lockBodyScroll() {
    const scrollY = window.scrollY;
    document.body.dataset.scrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  const sideEl = document.getElementById('side');
  if (!sideEl) return;

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.attributeName === 'class') {
        if (sideEl.classList.contains('--active')) {
          lockBodyScroll();
        } else {
          unlockBodyScroll();
        }
      }
    }
  }).observe(sideEl, { attributes: true });
})();

// ── Community page: "What's happening" category filter ───────────────────────
// Pure client-side — all cards are already on the page, so filtering is just
// show/hide. Delegated on document, with no setup-time existence check on
// the grid/pills: this file is loaded on every page via <script defer>, and
// a one-time "if (!grid) return" here would permanently skip attaching the
// listener whenever the grid isn't in the DOM at the exact moment this
// script runs — which is normal in the Shopify theme editor, where a
// section's HTML can be injected asynchronously (Section Rendering API)
// after the initial page load. Querying fresh inside the handler means it
// works regardless of when/how the markup actually arrived, and survives
// the editor re-rendering the section entirely.
(() => {
  document.addEventListener("click", (event) => {
    const pill = event.target.closest("[data-activity-filter]");
    if (!pill || !pill.closest(".community-activity-pills")) return;

    const grid = document.querySelector(".community-activity-grid");
    if (!grid) return;

    const filter = pill.dataset.activityFilter;

    document.querySelectorAll(".community-activity-pill").forEach((p) => {
      p.classList.toggle("--active", p === pill);
    });

    grid.querySelectorAll(".community-activity-card").forEach((card) => {
      const match = filter === "all" || card.dataset.activityCategory === filter;
      card.classList.toggle("--hidden", !match);
    });
  });
})();

// ── Redesigned policy pages (Privacy / Refund / Terms) ────────────────────────
// Gated entirely on the marker rendered from layout/theme.liquid for exactly
// those three paths — never runs on Contact Information or any other page,
// even though the selectors below would technically match there too, since
// the marker (and therefore this whole block) simply won't exist.
//
// There's no template/section file for policy pages in this theme at all
// (Shopify renders them via a fixed internal template), so this can only be
// built by walking the already-rendered DOM client-side — there's no Liquid
// loop that could see the policy body's heading structure.
(() => {
  const marker = document.querySelector('[data-policy-redesign="true"]');
  if (!marker) return;

  const body = document.querySelector('.shopify-policy__body');
  const rte = body ? body.querySelector('.rte') : null;
  if (!body || !rte) return;

  const allHeadings = Array.from(rte.querySelectorAll('h1, h2, h3, h4, h5, h6'));
  // Graceful fallback: no real headings at all — leave the content exactly
  // as Shopify rendered it, no sidebar, no numbering, nothing to break.
  if (allHeadings.length === 0) return;

  const levelOf = (h) => parseInt(h.tagName.charAt(1), 10);
  const mainLevel = Math.min(...allHeadings.map(levelOf));
  const subLevel = mainLevel + 1;
  const mainHeadings = allHeadings.filter((h) => levelOf(h) === mainLevel);
  const subHeadings = allHeadings.filter((h) => levelOf(h) === subLevel);

  function isBeforeFirstHeading(el) {
    const first = allHeadings[0];
    if (!first) return true;
    return !!(el.compareDocumentPosition(first) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  // "Last updated: ..." and a title-repeat line are both hidden (not
  // removed) only when reliably matched — otherwise left exactly as-is.
  // Checked against the first one or two <p> elements in document order,
  // regardless of whether the policy wraps its content in an extra plain
  // <div> (Privacy Policy does; Refund/Terms don't) — querySelectorAll
  // finds them either way.
  const paragraphs = Array.from(rte.querySelectorAll('p'));
  let lastUpdatedText = null;
  let nextIndex = 0;

  if (
    paragraphs[0] &&
    isBeforeFirstHeading(paragraphs[0]) &&
    /^last updated:?\s*\S/i.test(paragraphs[0].textContent.trim())
  ) {
    lastUpdatedText = paragraphs[0].textContent.trim();
    paragraphs[0].classList.add('policy-hide-line');
    nextIndex = 1;
  }

  const titleCandidate = paragraphs[nextIndex];
  const pageTitleEl = document.querySelector('.shopify-policy__title h1');
  const pageTitle = pageTitleEl ? pageTitleEl.textContent.trim().toLowerCase() : '';
  if (titleCandidate && pageTitle && isBeforeFirstHeading(titleCandidate)) {
    const candidateText = titleCandidate.textContent.trim().toLowerCase();
    // Length-guarded so a long substantive opening paragraph that merely
    // mentions the policy name somewhere isn't mistaken for a title repeat.
    if (candidateText.length < 120 && candidateText.indexOf(pageTitle) !== -1) {
      titleCandidate.classList.add('policy-hide-line');
    }
  }

  function slugify(text) {
    return (
      text
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section'
    );
  }

  subHeadings.forEach((h) => h.classList.add('policy-sub-heading'));

  const usedIds = {};
  const contentsItems = mainHeadings.map((heading, index) => {
    const number = String(index + 1).padStart(2, '0');

    let id = slugify(heading.textContent);
    if (usedIds[id]) {
      usedIds[id] += 1;
      id = id + '-' + usedIds[id];
    } else {
      usedIds[id] = 1;
    }
    heading.id = id;

    // Wrap in place: the original heading element is moved (not cloned or
    // rewritten) into a new wrapper alongside a new number element, so its
    // text content is byte-for-byte unchanged — only its DOM position and
    // presentation change.
    const wrapper = document.createElement('div');
    wrapper.className = 'policy-section-heading';
    heading.parentNode.insertBefore(wrapper, heading);
    const numberEl = document.createElement('span');
    numberEl.className = 'policy-section-number';
    numberEl.textContent = number;
    wrapper.appendChild(numberEl);
    wrapper.appendChild(heading);

    return { number: number, id: id, text: heading.textContent.trim() };
  });

  // Sidebar: prepended into .shopify-policy__body so it and .rte are the
  // only two children — that's what the CSS grid-template-columns targets.
  const nav = document.createElement('nav');
  nav.className = 'policy-contents';
  nav.setAttribute('aria-label', 'Contents');

  const header = document.createElement('div');
  header.className = 'policy-contents-header';
  const label = document.createElement('div');
  label.className = 'policy-contents-label';
  label.textContent = 'Contents';
  const toggle = document.createElement('span');
  toggle.className = 'policy-contents-toggle';
  toggle.setAttribute('aria-hidden', 'true');
  toggle.textContent = '▾';
  header.appendChild(label);
  header.appendChild(toggle);
  nav.appendChild(header);

  if (lastUpdatedText) {
    const updated = document.createElement('div');
    updated.className = 'policy-contents-updated';
    updated.textContent = lastUpdatedText;
    nav.appendChild(updated);
  }

  const divider = document.createElement('hr');
  divider.className = 'policy-contents-divider';
  nav.appendChild(divider);

  const list = document.createElement('ul');
  list.className = 'policy-contents-list';
  contentsItems.forEach((item) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + item.id;
    const numSpan = document.createElement('span');
    numSpan.className = 'policy-contents-list-number';
    numSpan.textContent = item.number;
    const textSpan = document.createElement('span');
    textSpan.textContent = item.text;
    a.appendChild(numSpan);
    a.appendChild(textSpan);
    a.addEventListener('click', (event) => {
      event.preventDefault();
      const target = document.getElementById(item.id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', '#' + item.id);
      }
    });
    li.appendChild(a);
    list.appendChild(li);
  });
  nav.appendChild(list);

  body.insertBefore(nav, body.firstChild);

  // Mobile: starts collapsed, tap the label to expand. Desktop ignores
  // --collapsed entirely via CSS (only applies under the 900px breakpoint).
  if (window.matchMedia('(max-width: 900px)').matches) {
    nav.classList.add('--collapsed');
  }
  header.addEventListener('click', () => {
    nav.classList.toggle('--collapsed');
  });

  // Active-section highlight while scrolling.
  const links = Array.from(list.querySelectorAll('a'));
  if ('IntersectionObserver' in window) {
    const sectionEls = contentsItems.map((item) => document.getElementById(item.id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = sectionEls.indexOf(entry.target);
          if (idx === -1) return;
          links.forEach((a, i) => a.classList.toggle('--active', i === idx));
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    sectionEls.forEach((el) => observer.observe(el));
  }
})();
